import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { SummaryComponent } from './summary/summary.component';

import { AuthGuard } from '../auth.guard';

export const routing: Routes = [
  {
    path: 'quote',
    data: {
      breadcrumb_en: 'Quotes',
      breadcrumb_es: 'Cotizaciónes'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '', component: ListComponent,
        data: {
          breadcrumb_en: 'Quote List',
          breadcrumb_es: 'Lista de Cotizaciónes'
        }, },
      {
        path: 'list', component: ListComponent,
        data: {
          breadcrumb_en: 'Quote List',
          breadcrumb_es: 'Lista de Cotizaciónes'
        }, },
      {
        path: 'add', component: AddComponent,
        data: {
          breadcrumb_en: 'Add New Quote',
          breadcrumb_es: 'Anadir Nuevo Cotización'
        }, },
      {
        path: ':quoteId', component: SummaryComponent,
        data: {
          breadcrumb_en: 'Edit Quote',
          breadcrumb_es: 'Editar Cotización'
        }, },
    ]
  }
];
